import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import { Info } from "lucide-react";
import colors from "../../utils/colors";
import LayerdIcon from "./LayerdIcon";

/**
 * Inline info icon beside form/page headings. Opens a wide-friendly tooltip
 * explaining what the form or configuration section does.
 */
export default function FormHelpTooltip({ tooltip, size = "default", placement = "top" }) {
  if (!tooltip) return null;
  const px = size === "small" ? 14 : 16;
  return (
    <Tooltip
      title={tooltip}
      placement={placement}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 360,
            fontSize: 12,
            lineHeight: "18px",
            color: "#fff",
            backgroundColor: "#1F2937",
            "& .MuiTooltip-arrow": { color: "#1F2937" },
            p: 1.5,
          },
        },
      }}
    >
      <IconButton
        size="small"
        aria-label="More information"
        sx={{
          p: 0.25,
          ml: 0.5,
          flexShrink: 0,
          verticalAlign: "middle",
          color: colors.primary?.[300] || "#6371F7",
          "&:hover": {
            color: colors.primary?.[500] || "#4338ca",
            backgroundColor: "rgba(99, 113, 247, 0.08)",
          },
        }}
      >
        <LayerdIcon icon={Info} size={px} color="primaryLight" aria-hidden />
      </IconButton>
    </Tooltip>
  );
}
